import React, { FC } from "react";
import { user } from "./ChatBot";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { TgkChatMessageTemplateProps } from "./types";
import { sanitizeHtml } from "./sanitizeHtml";

const useStyles = makeStyles({
  baseMessage: {
    borderRadius: "12px",
    paddingBlock: ".5rem",
    paddingInline: ".75rem",
  },
  userMessage: {
    color: "white",
    backgroundColor: "var(--color-blue)",
    borderBottomRightRadius: "2px",
  },
  botMessage: {
    color: "black",
    backgroundColor: "#dadada",
    borderBottomLeftRadius: "2px",
  },
  actionButton: {
    backgroundColor: "white",
    border: "2px solid var(--color-blue)",
    borderRadius: "6px",
    color: "var(--color-blue)",
    fontWeight: 500,
    paddingBlock: ".5rem",
    paddingInline: ".75rem",
    cursor: "pointer",
    fontSize: "inherit",
    lineHeight: "normal",
  },
  actionLabel: {
    color: "#616161",
    fontWeight: 500,
    fontSize: "inherit",
    lineHeight: "normal",
    paddingBlock: ".25rem",
    paddingInline: "0",
    textAlign: "right" as const,
  },
});

const ChatBotMessageTemplate: FC<TgkChatMessageTemplateProps> = ({ item }: TgkChatMessageTemplateProps) => {
  const classes = useStyles();

  // Action messages are rendered without the chat bubble wrapper — only the button/label is visible.
  if (item.messageType === "action") {
    if (item.actionStyle === "label") {
      return <span className={classes.actionLabel}>{item.actionLabel}</span>;
    }

    return (
      <button className={classes.actionButton} onClick={item.onAction}>
        {item.actionLabel}
      </button>
    );
  }

  const messageStyle = mergeClasses(
    classes.baseMessage,
    item.author.id === user.id ? classes.userMessage : classes.botMessage
  );

  let content: React.ReactElement | null;
  switch (item.messageType) {
    case "loading":
      content = <Spinner size={SpinnerSize.xSmall} id="spinner" />;
      break;
    case "message":
    default:
      if (item.tplOverride) {
        content = item.tplOverride();
      } else if (item.html) {
        content = <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.html) }} />;
      } else {
        content = <div>{item.text}</div>;
      }
      break;
  }

  return <div className={messageStyle}>{content}</div>;
};

export default ChatBotMessageTemplate;
